import { render, staticRenderFns } from "./AddSupply.vue?vue&type=template&id=676f5852&scoped=true"
import script from "./AddSupply.vue?vue&type=script&lang=js"
export * from "./AddSupply.vue?vue&type=script&lang=js"
import style0 from "./AddSupply.vue?vue&type=style&index=0&id=676f5852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f5852",
  null
  
)

export default component.exports